import { FC } from 'react';
// components
import AddSandCoatingFormulationForm from 'components/main/SandCoatingFormulation/Edit';

const AddSandCoatingFormulation: FC = () => <AddSandCoatingFormulationForm />;

export default AddSandCoatingFormulation;
